import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const userNavEntry = {
    id: 'user',
    prefix: 'User_',
    to: { screen: 'User_Home', params: {} },
    label: ({ translate }) => translate('Profile'),
    renderIcon: (color, size) => (React.createElement(FeatherIcon, { name: "user", color: color, size: size })),
    isVisible: () => true,
    placements: ['tab', 'sidebar-profile'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(userNavEntry, ctx, 'User_Home', Home)));
    },
};
export function renderUserTabRoutes(ctx) {
    return userNavEntry.renderTabRoutes(ctx);
}
